<div class="flex flex-col h-screen">
    <app-header class=""></app-header>
    <div class="bg-gradient-b-gray-white flex-grow flex-shrink-0 p-6 sm:p-8">
        <router-outlet></router-outlet>
    </div>
    <div class="flex items-center justify-center">
        <app-document-footer class="w-full sm:w-3/4"></app-document-footer>
    </div>
</div>